"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostCSSDriver = void 0;
var memory_minimal_fs_1 = require("./memory-minimal-fs");
var PostCSSDriver = /** @class */ (function () {
    function PostCSSDriver(initialBuildHook) {
        this.initialBuildHook = initialBuildHook;
        this.fsSource = {};
        this.entries = [];
        var _a = memory_minimal_fs_1.createMinimalFS({ files: this.fsSource }), fs = _a.fs, requireModule = _a.requireModule;
        this.fs = fs;
        this.requireModule = requireModule;
        this.buildHooks = [];
        this.fileHooks = [];
        initialBuildHook && this.registerBuildHook(initialBuildHook);
    }
    PostCSSDriver.prototype.setEntries = function (entries) {
        this.entries = entries;
    };
    PostCSSDriver.prototype.writeFile = function (path, content) {
        this.fs.writeFileSync(path, content);
        if (this.fileHooks.length) {
            this.fileHooks.forEach(function (hook) { return hook(content, [path]); });
        }
    };
    PostCSSDriver.prototype.readFile = function (path) {
        return (this.fsSource[path] && this.fsSource[path].content) || null;
    };
    PostCSSDriver.prototype.removeFile = function (path) {
        this.fs.removeFileSync(path);
    };
    PostCSSDriver.prototype.buildCSS = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, entries = _b.entries, _c = _b.emitBuild, emitBuild = _c === void 0 ? true : _c;
        var entriesArray = entries || this.entries;
        var css = entriesArray.map(function (path) { return _this.readFile(path); }).join('\n');
        if (this.buildHooks.length && emitBuild !== false) {
            this.buildHooks.forEach(function (hook) { return hook(css, entriesArray); });
        }
        return css;
    };
    /*
    sets a single event listener which will be fire when
    - output (built) css changes - if fileChangeHook is false (default)
    OR
    - a source file changes - if fileChangeHook is true
     */
    //TODO change function names to be more generic and deprecate
    PostCSSDriver.prototype.setBuildHook = function (buildHook, fileChangeHook) {
        if (fileChangeHook === void 0) { fileChangeHook = false; }
        this.initialBuildHook = buildHook;
        if (fileChangeHook) {
            this.fileHooks = [buildHook];
        }
        else {
            this.buildHooks = [buildHook];
        }
    };
    /*
    Registers an event listener which will be fire when
    - output (built) css changes - if fileChangeHook is false (default)
    OR
    - a source file changes - if fileChangeHook is true
     */
    PostCSSDriver.prototype.registerBuildHook = function (buildHook, fileChangeHook) {
        if (fileChangeHook === void 0) { fileChangeHook = false; }
        var hookArray;
        if (fileChangeHook) {
            hookArray = this.fileHooks;
        }
        else {
            hookArray = this.buildHooks;
        }
        hookArray.push(buildHook);
    };
    PostCSSDriver.prototype.unregisterBuildHook = function (buildHook, fileChangeHook) {
        if (fileChangeHook === void 0) { fileChangeHook = false; }
        var hookArray;
        if (fileChangeHook) {
            hookArray = this.fileHooks;
        }
        else {
            hookArray = this.buildHooks;
        }
        var hookIndex = hookArray.indexOf(buildHook);
        !!~hookIndex && hookArray.splice(hookIndex, 1);
    };
    return PostCSSDriver;
}());
exports.PostCSSDriver = PostCSSDriver;
//# sourceMappingURL=postcss-driver.js.map